import { MDSidebar } from 'md-sidebarjs';
import { useEffect, useState } from 'react';
import { useErrorHandler } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { DEFAULT_THEME } from '@/config';
import { getMyServices } from '@/features/myServices';
import { useAuth } from '@/lib/auth';
import { getAllAxiosData, GetterAxios } from '@/lib/axios';
import { ServiceTypes } from '@/types';
import storage from '@/utils/storage';

import { SpinnerContainer } from '../Containers/SpinnerContainer';

export type PrivateSidebarProps = {
  onChangeCompany?: (companyId: string) => void;
};

export const PrivateSidebar = ({ onChangeCompany }: PrivateSidebarProps) => {
  const { getAuthInfo } = useAuth();
  const { i18n } = useTranslation();
  const [services, setServices] = useState<ServiceTypes[] | undefined>(undefined);
  const handleError = useErrorHandler();
  const authInfo = getAuthInfo();

  useEffect(() => {
    if (!services) {
      const getters: GetterAxios[] = [{ callback: getMyServices, parameters: {} }];
      const setters: any = [setServices];

      const pageData = getAllAxiosData(getters, setters);
      pageData.catch((error) => {
        handleError(error);
      });
    }
  }, [services, handleError]);

  if (!services) {
    return <SpinnerContainer />;
  }

  storage.setSidebarServices(authInfo.getGroupId(), authInfo.getUserId(), services);

  return (
    <MDSidebar
      lang={i18n.language}
      theme={DEFAULT_THEME}
      servicesConfig={services}
      customClassName={null}
      preventDefaultLinks={false}
      companyId={authInfo.getCompanyId()}
      groupId={authInfo.getGroupId()}
      userId={authInfo.getUserId()}
      isEmBlue={authInfo.getEntrypoint() === 'emBlue'}
      showCompanies={false}
      service="payments"
      onChangeCompany={onChangeCompany}
    />
  );
};
